import { CallbackQueue } from "../../../lib/callback-queue/callback-queue";

export const voicePlayerCallbackQueue = new CallbackQueue();